import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Table from 'components/Shared/Table'
import { Loader } from 'components/Shared/Loader'
import { ErrorDialog } from 'components/Shared/Dialogs/ErrorDialog'
import { RelatedOrdersErrorMessage } from 'components/Shared/Dialogs/DialogContents'
import { deleteCar, fetchCars } from 'services/CarService'
import { useErrorHandling } from 'context/errorHandling'
import { HTTP_404_ERROR } from 'Constants'
import { CAR_CREATE, CAR_DELETE, CAR_EDIT, useAuth } from 'context/auth'
import { createColumns } from './columns'

export function CarsTable () {
  const [columnDefinitions, setColumnDefinitions] = useState()
  const [relatedOrdersErrors, setRelatedOrdersErrors] = useState([])
  const { handleError } = useErrorHandling()
  const { hasAnyPrivileges } = useAuth()

  const history = useHistory()

  useEffect(() => {
      setColumnDefinitions(createColumns(hasAnyPrivileges))
  }, [hasAnyPrivileges, handleError])

  const addCar = () => {
    history.push('/cars/create')
  }

  const copyCar = row => {
    history.push({
      pathname: '/cars/create',
      state: { idOfCopiedCar: row.id }
    })
  }

  const showCarDetails = (row) => {
    history.push('/cars/details/' + row.id)
  }

  const editCar = (row) => {
    history.push('/cars/edit/' + row.id)
  }

  const onDeleteError = (error) => {
    if (error?.response?.data?.data?.ordersId) {
      setRelatedOrdersErrors(error.response.data.data.ordersId)
    } else {
      handleError(error, {
        [HTTP_404_ERROR]: 'notifications.error.delete'
      }).then(() => setRelatedOrdersErrors([]))
    }
  }

  const hasCreateAuthority = hasAnyPrivileges([CAR_CREATE])

  const addButton = {
    label: 'carsTable.addButtonLabel',
    onClick: addCar,
    isClickable: hasCreateAuthority
  }

  const menuOptions = {
    edit: {
      onClick: editCar,
      isEditable: () => hasAnyPrivileges([CAR_EDIT])
    },
    copy: {
      onClick: copyCar,
      isCopyable: () => hasCreateAuthority
    },
    delete: {
      onDelete: deleteCar,
      onDeleteError: onDeleteError,
      deleteDialog: {
        content: 'carsTable.deleteDialog.content',
        title: 'carsTable.deleteDialog.title'
      },
      isDeletable: () => hasAnyPrivileges([CAR_DELETE])
    }
  }

  return (
    columnDefinitions ?
      <>
        <Table title={'car.title'}
               addButton={addButton}
               fetchData={fetchCars}
               columns={columnDefinitions}
               tableKey={'cars'}
               menu={menuOptions}
               onRowClick={showCarDetails}/>
        <ErrorDialog
          open={!!relatedOrdersErrors && relatedOrdersErrors.length > 0}
          onClose={() => {
            setRelatedOrdersErrors([])
          }}
          content={<RelatedOrdersErrorMessage idList={relatedOrdersErrors}/>}
        />
      </>
      : <Loader/>
  )
}
